<template>
    <b-overlay :show="loadingProgress !== 100" rounded="lg">

        <b-container id="app" fluid>
            <b-navbar>
                <b-navbar-brand href="#">{{ appName }}</b-navbar-brand>
                <b-navbar-toggle target="navCollapse"></b-navbar-toggle>
                <b-collapse id="navCollapse" is-nav>
                    <b-container fluid>
                        <b-col cols="3">
                            Load subgraph to match:
                            <b-form-select size="sm" v-model=candidateName :options=candidateNames></b-form-select>
                        </b-col>
                        <b-col cols="6">
                            {{ subGraphInfo }}
                            {{ progressStatus }}
                        </b-col>
                        <b-col cols="3" class="text-right">
                            <b-button class="ml-2 p-1" size="sm" v-b-modal.pairingModal
                                      variant="outline-primary" :disabled="pairingList.length === 0">
                                <b-icon-table class="mr-1"></b-icon-table>
                                Show pairing list
                            </b-button>
                            <b-modal size="lg" id="pairingModal" hide-footer hide-header>
                                <DistanceTableView :items=matchedDistances
                                                   :metrics="metricList"></DistanceTableView>
                            </b-modal>

                        </b-col>
                    </b-container>
                </b-collapse>
            </b-navbar>
            <b-container fluid>
                <b-row fluid>
                    <b-col cols="6">
                        <b-row fluid>
                            <b-col cols="3">
                                <h1>Template Graph</h1>
                                <NodeLinkDiagram id="templateView" :legend=false
                                                 :data=templateGraph></NodeLinkDiagram>
                            </b-col>
                            <b-col cols="6">
                                <h1>Template Temporal Bars</h1>
                                <LocationTimeBars id="locationBarsView" v-if="template_.edges.length > 0"
                                                  :data=template_.edges :filter="false"></LocationTimeBars>
                            </b-col>
                            <b-col cols="3">
                                <h1>Candidate Graph</h1>
                                <NodeLinkDiagram id="candidateView" :legend=false
                                                 v-if="candidateGraph.nodes.length < 100"
                                                 :data=candidateGraph></NodeLinkDiagram>
                                <div class="text-secondary"><em>{{ candidateGraphSummary }}</em></div>
                            </b-col>
                            <b-col cols="3" v-if="matchGraph.nodes.length > 0" class="mt-4">
                                <h1>Match Graph </h1>
                                <NodeLinkDiagram id="matchView" :legend=false
                                                 :data=matchGraph></NodeLinkDiagram>
                            </b-col>
                            <b-col cols="6" v-if="matchGraph.nodes.length > 0" class="mt-4">
                                <h1>Match Temporal Bars</h1>
                                <LocationTimeBars id="locationBarsCandidateView"
                                                  :data=candidate_.edges :filter="true"
                                                  :items="pairingCandidateSet"></LocationTimeBars>
                            </b-col>
                            <b-col cols="2" v-if="matchGraph.nodes.length > 0" class="mt-4">
                                <h1>Match Distance Average </h1>
                                <BarChart id="matchMetric"
                                          :data="matchMetrics"
                                          :metrics="metricList"></BarChart>
                            </b-col>
<!--                            <b-col cols="12" v-if="matchGraph.nodes.length > 0">-->
<!--                                <h1>Match Communication Agreement & Distance </h1>-->
<!--                                <ParallelArcDiagram id="matchCommunication"-->
<!--                                                    :data="pendingCommunicationGraph"-->
<!--                                                    :metrics="metricList"></ParallelArcDiagram>-->
<!--                            </b-col>-->
                        </b-row>
                    </b-col>
                    <b-col cols="6">
                        <b-card>
                            <h1>Pairwise distance between person nodes</h1>
                            <DistanceTableView v-if="distances.length > 0"
                                               :items=filteredDistances
                                               :metrics="metricList"
                                               @selected="onSelectedPairing"></DistanceTableView>
                        </b-card>
                        <b-card v-if="pendingPair" class="my-1">
                            <h1>Pending person pairing (
                                <b-badge>template</b-badge>
                                {{ pendingPair.templateID }},
                                <b-badge>candidate</b-badge>
                                {{ pendingPair.candidateID }})
                            </h1>
                            <b-row>
                                <b-col cols="4">
                                    <b-card body-class="p-2" title="Demographics" class="text-center">
                                        <b-row>
                                            <b-col cols="6">
                                                <Heatmap id="templateDemographics" title="template"
                                                         :properties="demographics"
                                                         :data="findNode(pendingPair.templateID, true)"></Heatmap>
                                            </b-col>
                                            <b-col cols="6">
                                                <Heatmap id="candidateDemographics" title="candidate"
                                                         :properties="demographics"
                                                         :data="findNode(pendingPair.candidateID, false)"></Heatmap>
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                </b-col>
                                <b-col cols="4">
                                    <b-card body-class="p-2" title="Distances" class="text-center">
                                        <BarChart id="selectionMetric"
                                                  :data="pendingMetrics"
                                                  :metrics="metricList"></BarChart>
                                    </b-card>
                                </b-col>
                                <b-col cols="4">
                                    <b-card body-class="p-2" title="Communication neighbors" class="text-center">
                                        <ParallelArcDiagram id="selectionCommunication"
                                                            :data="pendingCommunicationGraph"
                                                            :metrics="metricList"></ParallelArcDiagram>
                                    </b-card>
                                </b-col>
                                <b-col cols="12">
                                    <b-card body-class="p-2" title="Temporal Bars" class=" my-2">
                                        <h2>template</h2>
                                        <LocationTimeBars id="locationBarsPairTemplate"
                                                          v-if="template_.edges.length > 0"
                                                          :data=template_.edges :filter="true"
                                                          :items="pendingPairingTemplateSet"></LocationTimeBars>
                                        <div v-else>no travel</div>

                                        <h2>candidate</h2>
                                        <!--                                      Hide view if... -> some(e => e.eType === 6 && (pendingPairingTemplateSet.has(e.Source) || pendingPairingTemplateSet.has(e.Target)))"-->
                                        <LocationTimeBars id="locationBarsPairCandidate"
                                                          v-if="candidate_.edges.length > 0"
                                                          :data=candidate_.edges :filter="true"
                                                          :items="pendingPairingCandidateSet"></LocationTimeBars>
                                        <span v-else>no travel</span>
                                    </b-card>
                                </b-col>

                                <b-col cols="12">
                                    <b-button class="m-1" variant="success" size="sm" v-on:click="validatePairing()">
                                        Validate
                                    </b-button>
                                    <b-button class="m-1" size="sm" v-on:click="cancelPairing()">Cancel</b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>

            </b-container>
        </b-container>
    </b-overlay>

</template>

<script>
    import NodeLinkDiagram from "./components/NodeLinkDiagram"
    import DistanceTableView from "./components/DistanceTableView"
    import ParallelArcDiagram from "./components/ArcDiagram"
    import BarChart from "./components/BarChart"
    import Heatmap from "./components/Heatmap"
    import LocationTimeBars from "./components/LocationTimeBars"

    import locationParing from './assets/locationPairing.json'
    import templateNodes from '../public/data/template_nodes.csv'
    import templateEdges from '../public/data/template_edges.csv'
    import CHANNELS from './assets/channels.json'
    import DEMOGRAPHICS from './assets/demographics.json'
    import NODE_TYPES from './assets/NodeTypes.json'
    import EDGE_TYPES from './assets/eType.json'
    import axios from 'axios'
    import Papa from 'papaparse'
    import _ from 'lodash'

    const METRICS = ['demographicsCosine', 'travelJaccard', 'dtwAllEdges', 'dtwTravel', 'dtwCommunication', 'glEmail-undir5', 'glPhone-undir5']
    const DATASETS = ["Graph1", "Graph2", "Graph3", "best", "seed1-travels-demo-time-greedy2", "seed3-travels-demo-time-greedy2", "buyer_seller_with_some_neighbors_candidate0", "buyer_seller_with_some_neighbors_candidate1", "buyer_seller_with_some_neighbors_candidate2"]

    const csvParseOptions = {
        dynamicTyping: true,
        header: true,
        skipEmptyLines: true
    }

    function union(setA, setB) {
        let _union = new Set(setA)
        for (let elem of setB) {
            _union.add(elem)
        }
        return _union
    }

    export default {
        name: "App",
        components: {
            ParallelArcDiagram,
            DistanceTableView,
            NodeLinkDiagram,
            LocationTimeBars,
            BarChart,
            Heatmap
            // AdjacencyMatrix
        },
        data() {
            return {
                appName: "Matchmaker",
                metricList: METRICS,
                subGraphInfo: "",
                loadingProgress: 0,
                candidateNames: DATASETS,
                displayedChannels: [0, 1, 2, 3, 4, 5, 6],
                CHANNELS,
                demographics: DEMOGRAPHICS,
                pairing: {}, // Only person nodes for now, key is candidate id as string, value is template id
                template_: {nodes: templateNodes, edges: templateEdges},
                candidate_: {nodes: [], edges: []},
                candidateName: "Graph1",
                distances: [],
                pendingPair: null

            }
        },
        methods: {
            validatePairing() {
                this.$set(this.pairing, this.pendingPair.candidateID.toString(), this.pendingPair.templateID)
                this.pendingPair = null
            },
            cancelPairing() {
                this.pendingPair = null
            },
            onSelectedPairing(pair) {
                this.pendingPair = pair
            },
            getCommunicationNeighborIds(graph, nodeID, filterSet) { // Only for communication channel 0&1
                let edges = graph.edges.filter(e =>
                    (e.eType === 0 || e.eType === 1) &&
                    ((e.Source === nodeID && filterSet.has(e.Target)) || (e.Target === nodeID && filterSet.has(e.Source))))
                let nodeIds = union(new Set(edges.map(e => e.Source)), new Set(edges.map(e => e.Target)))
                if (nodeIds.size === 0) nodeIds = new Set([nodeID])
                return nodeIds
            },
            async loadCandidate(name) {
                this.loadingProgress = 0
                this.pendingPair = null
                this.pairing = _.clone(locationParing)
                this.candidate_ = {nodes: [], edges: []}
                this.distances = []
                this.subGraphInfo = ""
                axios.all([
                    axios.get(`./data/${name}/candidate_nodes.csv`),
                    axios.get(`./data/${name}/candidate_edges.csv`),
                    axios.get(`./data/${name}/distances.csv`)
                ])
                    .then(axios.spread((nodes, edges, distances) => {
                        this.candidate_ = {
                            nodes: Papa.parse(nodes.data, csvParseOptions).data,
                            edges: Papa.parse(edges.data, csvParseOptions).data
                        }
                        this.distances = Papa.parse(distances.data, csvParseOptions).data
                        this.loadingProgress = 100
                    }))
                    .catch(error => {
                        console.log(error);
                    })

                // Load initial pairing as well if any
                axios
                    .get(`./data/${name}/pairing.json`)
                    .then(response => {
                        this.subGraphInfo = `Starting with ${Object.keys(response.data).length} preloaded pair(s).`
                        // Merge with location pairing
                        this.pairing = {...locationParing, ...response.data}
                    })

            },
            nodeStatus(nodeID, isTemplate) {
                if (this.pendingPair !== null && this.pendingPair[isTemplate ? "templateID" : "candidateID"] === nodeID) {
                    return "pending"
                }
                let matched = null
                if (isTemplate) matched = this.pairingTemplateSet
                else matched = this.pairingCandidateSet
                if (matched.has(nodeID)) return "matched"
                return "unassigned"
            },
            findNode(nodeID, isTemplate) {
                let intNodeID = parseInt(nodeID)
                if (isTemplate) return this.template_.nodes.find(n => n.NodeID === intNodeID)
                return this.candidate_.nodes.find(n => n.NodeID === intNodeID)
            },
            inducedSubgraph(graph, nodeSet) {
                return {
                    edges: graph.edges.filter(e => nodeSet.has(e.Source) && nodeSet.has(e.Target)),
                    nodes: graph.nodes.filter(n => nodeSet.has(n.NodeID))
                }
            }
        },
        computed: {
            candidateGraphSummary() {
                const nbNodes = this.candidate_.nodes.length
                const pcMatch = Object.keys(this.pairing).length / nbNodes
                const nbEdges = this.candidate_.edges.length
                const nbNodePerType = NODE_TYPES.map((type, i) => ({
                    "type": type,
                    "amount": this.candidate_.nodes.filter(n => n.NodeType === i + 1).length
                }))
                const nbEdgePerType = EDGE_TYPES.map((type, i) => ({
                    "type": type,
                    "amount": this.candidate_.edges.filter(n => n.eType === i).length
                }))
                let summary = `${nbNodes} nodes (${pcMatch.toFixed(2)}% matched), ${nbEdges} edges.\n`
                summary = summary + '\tNodes:'
                summary = summary.concat(nbNodePerType.map(s => `\t${s.type}: ${s.amount}`))
                summary = summary + '\n\tEdges:'
                summary = summary.concat(nbEdgePerType.map(s => `\t${s.type}: ${s.amount}`))
                return summary
            },
            pairingList() {
                return Object.entries(this.pairing).map(e => ({"templateID": e[1], "candidateID": parseInt(e[0])}))
            },
            pairingTemplateSet() {
                return new Set(Object.values(this.pairing));
            },
            pairingPersonCandidateSet() {
                if (this.candidate_.nodes.length === 0 || Object.keys(this.pairing).length === 0) return new Set()
                let pairingDict = _.clone(this.pairing)
                Object.keys(pairingDict).forEach(candidateID => {
                    const nodeProps = this.findNode(candidateID, false)
                    if (nodeProps && nodeProps.NodeType !== 1)
                        delete pairingDict[candidateID]
                })
                return new Set(Object.entries(pairingDict).map(e => parseInt(e[0])));
            },
            pairingCandidateSet() {
                return new Set(Object.entries(this.pairing).map(e => parseInt(e[0])));
            },
            pendingPairingCandidateSet() {
                return new Set([parseInt(this.pendingPair.candidateID)]);
            },
            pendingPairingTemplateSet() {
                return new Set([parseInt(this.pendingPair.templateID)]);
            },
            templateGraph() {
                return {
                    nodes: this.template_.nodes.map(n => ({"status": this.nodeStatus(n.NodeID, true), ...n})),
                    edges: this.template_.edges
                }
            },
            candidateGraph() {
                return {
                    nodes: this.candidate_.nodes.map(n => ({"status": this.nodeStatus(n.NodeID, false), ...n})),
                    edges: this.candidate_.edges
                }
            },
            matchGraph() {
                return {
                    nodes: this.candidate_.nodes
                        .filter(n => this.pairingCandidateSet.has(n.NodeID))
                        .map(n => ({"status": this.nodeStatus(n.NodeID, false), ...n})),
                    edges: this.candidate_.edges.filter(e =>
                        this.pairingCandidateSet.has(e.Source) &&
                        this.pairingCandidateSet.has(e.Target)
                    )
                }
            },
            progressStatus() {
                const nbPersonNodes = this.template_.nodes.filter(n => n.NodeType === 1).length
                return `Matched: ${this.pairingPersonCandidateSet.size} / ${nbPersonNodes} person nodes of template.`
            },
            matchedDistances() {
                // Filter nodes that are not in the graphs for some reason -> TODO: check why!
                if (this.pairingTemplateSet.size > 0) {
                    return this.distances.filter(r =>
                        this.pairingTemplateSet.has(r.templateID) &&
                        this.pairing[r.candidateID.toString()] === r.templateID
                    )
                } else {
                    return []
                }
            },
            filteredDistances() {
                const templateNodeSet = new Set(this.template_.nodes.filter(n => n.NodeType === 1).map(n => n.NodeID))
                const candidateNodeSet = new Set(this.candidate_.nodes.filter(n => n.NodeType === 1).map(n => n.NodeID))
                // TODO: Need to filter nodes that are not in the graphs for some reason, incorect distance file...
                let distances = this.distances.filter(r => templateNodeSet.has(r.templateID) && candidateNodeSet.has(r.candidateID))
                if (this.pairingTemplateSet.size > 0) {
                    return distances.filter(r =>
                        !this.pairingTemplateSet.has(r.templateID) &&
                        !this.pairingCandidateSet.has(r.candidateID)
                    )
                } else {
                    return distances
                }
            },
            pairedCommunicationGraph() {
                return {
                    template: this.templateGraph,
                    candidate: this.matchGraph,
                    pairing: this.pairing
                }
            },
            pendingCommunicationGraph() {
                if (this.pendingPair) {

                    // Future pairing dict
                    let pairingDict = _.clone(this.pairing)
                    pairingDict[this.pendingPair.candidateID.toString()] = this.pendingPair.templateID
                    const reversePairingDict = _.invert(pairingDict)

                    let starPairingDict = {} // Neighborhood-filtered pairing

                    // Add neighborhood from candidate
                    const cPersonPairedFilter = union(this.pairingPersonCandidateSet, this.pendingPairingCandidateSet) // Only person
                    const candidateStarIds = this.getCommunicationNeighborIds(this.candidate_, this.pendingPair.candidateID, cPersonPairedFilter)
                    candidateStarIds.forEach(id => starPairingDict[id.toString()] = pairingDict[id.toString()])

                    // Add neighborhood from template
                    const tPersonPairedFilter = new Set([this.pendingPair.templateID])
                    this.pairingPersonCandidateSet.forEach(c => tPersonPairedFilter.add(this.pairing[c.toString()]))
                    const templateStarIds = this.getCommunicationNeighborIds(this.template_, this.pendingPair.templateID, tPersonPairedFilter)
                    templateStarIds.forEach(id => starPairingDict[reversePairingDict[id.toString()]] = id)

                    // Final filtering of distance list
                    const tFilter = new Set(Object.values(starPairingDict))
                    const cFilter = new Set(Object.keys(starPairingDict).map(e => parseInt(e)))
                    let pairing = this.distances.filter(r => tFilter.has(r.templateID) && starPairingDict[r.candidateID.toString()] === r.templateID)


                    // Extract graph and add status
                    let candidateStar = this.inducedSubgraph(this.candidate_, cFilter)
                    candidateStar.nodes = candidateStar.nodes.map(n => ({"status": this.nodeStatus(n.NodeID, false), ...n}))
                    let templateStar = this.inducedSubgraph(this.template_, tFilter)
                    templateStar.nodes = templateStar.nodes.map(n => ({"status": this.nodeStatus(n.NodeID, true), ...n}))

                    return {
                        template: templateStar,
                        candidate: candidateStar,
                        pairing: pairing
                    }
                } else {
                    return null
                }
            },
            matchMetrics() { // Average distance for pairing pairs, for every metric
                const pairedCandidateNodes = new Set(Object.keys(this.pairing).map(s => parseInt(s)))
                if (pairedCandidateNodes.size === 0) return null
                const distances = this.distances
                    .filter(r => (
                        pairedCandidateNodes.has(r["candidateID"]) &&
                        this.pairing[r["candidateID"].toString()] === r["templateID"])
                    )
                if (distances.length === 0) return null
                const avgFunc = arr => arr.reduce((sum, el) => sum + el, 0) / arr.length;
                return this.metricList.map(
                    metric => ({"category": metric, "amount": avgFunc((distances.map(r => r[metric])))})
                )
            },
            pendingMetrics() {
                if (this.pendingPair) {
                    return this.pendingPair.distances.map((e, i) => ({"category": this.metricList[i], "amount": e}))
                }
                return null
            }
        },
        mounted() {
            this.loadCandidate(this.candidateName)
        },
        watch: {
            candidateName: function (newCandidateName) {
                this.loadCandidate(newCandidateName)
            }

        }
    };
</script>

<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-size: small;

    }

    h1 {
        font-size: 12pt;
        color: gray;
    }

    h2 {
        font-size: 10pt;
        color: gray;
        text-align: left;
        text-transform: none;
        font-style: italic;
    }

    .card-title {
        font-variant: all-small-caps;
        font-size: 10pt;
        font-style: italic;
        color: gray;
        text-align: center;
    }

</style>


